import { Box, Text } from '@chakra-ui/react';
import React from 'react';
import { ScrollListProps } from '../../interfaces/components';

const ModernScrollList = ({ list }: ScrollListProps) => {
  return (
    <Box
      w="265px"
      h="400px"
      overflowY="auto"
      display="flex"
      flexFlow="row"
      flexWrap="wrap"
      rowGap="3"
      columnGap="3"
      justifyContent="center"
    >
      {list.map((shop: string) => (
        <Box
          key={shop}
          w="240px"
          h="42px"
          border="1px solid lightgray"
          display="inline-flex"
          justifyContent="center"
          alignItems="center"
        >
          <Text fontWeight="400" fontFamily="SangBleuBPLight" fontSize={['13px', '13px', '14px', '14px', '14px']}>
            {shop}
          </Text>
        </Box>
      ))}
    </Box>
  );
};

export default ModernScrollList;
